import React, {useState} from 'react';
// import {BsCheckCircleFill, BsCircle} from "react-icons/bs";
import {Button, Checkbox, Accordion, Grid, Box} from "@mui/material";
// import paths from "../../paths.json";
import Tooltip, {tooltipClasses} from '@mui/material/Tooltip';
// import {FiChevronDown, FiChevronUp} from 'react-icons/fi';
import {styled} from "@mui/material/styles";
// import MuiAccordionSummary from "@mui/material/AccordionSummary";
// import MuiAccordionDetails from "@mui/material/AccordionDetails";
import Fade from 'react-reveal/Fade';
import {BiInfoCircle} from 'react-icons/bi';
import {IoClose} from "react-icons/io5";
import HeroGradient from "../../media/site_media/illustrations/hero_graphic1.webp";
import '../../css/Dashboard.css';
import { useTranslation } from 'react-i18next';

const LightTooltip = styled(({ className, ...props }) => (
   <Tooltip {...props} classes={{ popper: className }} />
))(({ theme }) => ({
   [`& .${tooltipClasses.tooltip}`]: {
      backgroundColor: '#222222 !important',
      color: '#ffffff',
      boxShadow: theme.shadows[1],
      fontSize: 11,
      margin: '0px'
   },
}));

const titleStyle = {
   fontSize: '16px',
   fontWeight: '600',
   color: '#222222',
   margin: '0px'
}


const SectionItem = ({icon, checked, title, tooltipText, tooltipLink, description, buttonText, buttonAction, customComponent, showExitMark,
                        buttonTextSecondary, buttonActionSecondary, videoSrc, title1, title2, title3, description1, description2, asyncPage, windowWidth,
                        description3, titleicon1, titleicon2, titleicon3, noMembers, noPaidDMMembers, paidDMsActiveSettings, paidDMsModal, paidDMs_show, messagePage, isCoachingPage, isMessagesPage, ...props }) => {
   const { t } = useTranslation();
   const [isOpen, setIsOpen] = useState(false);
   const [videoLoaded, setVideoLoaded] = useState(false);

   const handleVideoLoad = () => {
      setVideoLoaded(true);
   };

   return (

      <div style={{ width: '100%', height: '100%', display: 'flex', minHeight: '300px', padding: '20px 0px', flexDirection: 'column', boxSizing: 'border-box' }}>

         <Grid
            container
            spacing={2}
            style={{
               boxSizing: 'border-box',
               backgroundColor: '#FFFFFF',
               border: '1px solid #E4EBF6',
               borderRadius: windowWidth > 600 ? '8px' : '0px',
               width: '100%',
               margin: '0px auto 25px',
               alignItems: 'left',
               position: 'relative',
            }}
         >
            {/* Left Grid */}
            <Grid xs={12} md={6} order={{xs: '2', md: '1'}} sx={{ display: 'flex', padding: '20px 0px', }}>
               <div style={{ display: 'flex', flexDirection: 'column', width: '90%', margin: windowWidth > 900 ? '20px 0px 20px 50px' : 'auto auto auto auto', textAlign: 'left' }}>
                  {/*<span style={{ fontSize: '45px', textAlign: 'center' }}>{icon}</span>*/}
                  <h2
                     style={{
                        fontSize: '22px',
                        fontWeight: 'bold',
                        color: 'black',
                        margin: '0px 0px 30px 0px',
                        textAlign: 'left',
                     }}
                  >
                     {title}
                     {tooltipLink !== null ? (
                        <LightTooltip title={tooltipText}>
                           <span style={{ marginLeft: '4px' }}>
                              <BiInfoCircle
                                 style={{ color: '#222222', verticalAlign: 'middle', marginTop: '-2px', cursor: 'pointer' }}
                              />
                           </span>
                        </LightTooltip>
                     ) : null}
                  </h2>
                  <Grid container sx={{ marginBottom: '15px' }}>
                     <Grid xs={12} sx={{ backgroundColor: '', }}>
                        <div style={{ display: 'flex', alignItems: 'center', marginBottom: '5px' }}>
                           <p style={titleStyle}>{title1} {titleicon1}</p>
                        </div>
                        <div style={{ display: 'flex', alignItems: 'center', marginBottom: '5px', fontSize: ((isCoachingPage || isMessagesPage) && windowWidth < 600) ? '7.5px' : '13px', fontWeight: '400', }}>
                           <p style={{ fontSize: ((isCoachingPage || isMessagesPage) && windowWidth < 600) ? '7.5px' : '13px', fontWeight: '400', color: '#6E89AF', margin: '0px' }}>{description1}</p>
                        </div>
                     </Grid>
                  </Grid>


                  <Grid container sx={{ marginBottom: '15px' }}>
                     <Grid xs={12} sx={{ backgroundColor: '', }}>
                        <div style={{ display: 'flex', alignItems: 'center', marginBottom: '5px' }}>
                           <p style={titleStyle}>{title2} {titleicon2}</p>
                        </div>
                        <div style={{ display: 'flex', alignItems: 'center', marginBottom: '5px', fontSize: '13px', fontWeight: '400', }}>
                           <p style={{ fontSize: '13px', fontWeight: '400', color: '#6E89AF', margin: '0px' }}>{description2}</p>
                        </div>
                     </Grid>
                  </Grid>


                  <Grid container>
                     <Grid xs={12} sx={{ backgroundColor: '', }}>
                        <div style={{ display: 'flex', alignItems: 'center', marginBottom: '5px' }}>
                           <p style={titleStyle}>{title3} {titleicon3}</p>
                        </div>
                        <div style={{ display: 'flex', alignItems: 'center', marginBottom: '5px', fontSize: ((isCoachingPage || isMessagesPage) && windowWidth < 600) ? '7.5px' : '13px', fontWeight: '400', }}>
                           <p style={{ fontSize: ((isCoachingPage || isMessagesPage) && windowWidth < 600) ? '7.5px' : '13px', fontWeight: '400', color: '#6E89AF', margin: '0px' }}>{description3}</p>
                        </div>
                     </Grid>
                  </Grid>
                  <Box sx={{ width: '100%', height: 'auto', display: 'flex', marginTop: '20px', flexDirection: { xs: 'column', md: 'row' } }}>
                     {buttonText !== '' ?
                        <Button
                           variant="contained"
                           disabled={props.noMembersYet ? true : false}
                           disableElevation
                           sx={{
                              padding: '7px 20px',
                              margin: '15px 0px 0px 0px',
                              textAlign: 'left',
                              borderRadius: '10px',
                              textTransform: 'none',
                              // border: '2px var(--brand-color) solid',
                              backgroundColor: 'var(--brand-color)',
                              '&:hover': {
                                 backgroundColor: 'var(--brand-color-hover)',
                                 // border: '2px var(--brand-color-hover) solid',
                              },
                           }}
                           onClick={buttonAction}
                        >
                           <span className="fa fa-search" style={{ fontWeight: '600', fontSize: '13px' }}>
                              {buttonText}
                           </span>
                        </Button>
                        :null}

                     {buttonTextSecondary !== '' ?

                        <Button
                           variant="contained"
                           disableElevation
                           sx={{
                              padding: '9px 20px',
                              margin: '15px 0px 0px 10px',
                              textAlign: 'left',
                              borderRadius: '10px',
                              textTransform: 'none',
                              color: 'var(--brand-color)',
                              backgroundColor: '#fff',
                              // border: '2px var(--brand-color) solid',
                              // backgroundColor: 'var(--brand-color)',
                              '&:hover': {
                                 backgroundColor: 'transparent',
                                 // border: '2px var(--brand-color-hover) solid',
                                 color: 'var(--brand-color-hover)',
                              },
                           }}
                           onClick={buttonActionSecondary}
                        >
                              <span className="fa fa-search" style={{ fontWeight: '600', fontSize: '13px' }}>
                                 {buttonTextSecondary}
                              </span>
                        </Button>
                        :
                        null
                     }
                  </Box>

                  {
                     noMembers &&
                     <div style={{ margin: '15px 0px 0px 0px' }}>
                        <p style={{ color: '#6E89AF', fontSize: '14px', margin: '0px' }}>{t('dashboard.sections.noCoachingMembers')}</p>
                        <p style={{ color: '#6E89AF', fontSize: '14px', margin: '0px' }}>{t('dashboard.sections.coachingGuidesLink')} <a style={{ color: '#6E89AF'}} href="https://help.withme.so/en/collections/7533680-1-1-a-synchronous-coaching" target="_blank">{t('dashboard.sections.coachingGuides')}</a></p>
                     </div>

                  }


                  {
                     messagePage &&
                     <>
                     {
                     (paidDMs_show === true) ?
                     <div style={{ margin: '15px 0px 0px 0px' }}>
                        <p style={{ color: '#6E89AF', fontSize: '14px', margin: '0px' }}>{t('dashboard.sections.messagesActive')}</p>
                     </div>
                     :
                     <div style={{ margin: '15px 0px 0px 0px' }}>
                        <p style={{ color: '#6E89AF', fontSize: '14px', margin: '0px' }}>{t('dashboard.sections.messagesInactive')}</p>
                     </div>

                  }
                     </>
                  }


                  

                  {customComponent !== null ? <>{customComponent}</> : null}
               </div>
            </Grid>

            {/* Right Grid */}
            <Grid xs={12} md={6} order={{xs: '1', md: '2'}} sx={{ display: 'flex', padding: '20px 0px',
               backgroundImage: `url(${HeroGradient})`,
               backgroundPosition: 'left',
               borderTopRightRadius: windowWidth > 900 ? '8px' : '0px',
               borderBottomRightRadius: windowWidth > 900 ? '8px' : '0px',
               backgroundRepeat: 'no-repeat',
               backgroundSize: 'cover'
            }}>
               {showExitMark ? (
                  <div
                     style={{
                        position: 'absolute',
                        top: '10px',
                        right: '10px',
                        fontSize: '20px',
                        padding: '5px',
                     }}
                  >
                     <IoClose style={{ color: '#AFBED3', cursor: 'default', backgroundColor: 'transparent' }} />
                  </div>
               ) : null}

               <Fade style={{ width: '100%', height: '100%', display: 'flex', }}>

                  {/*<LazyVideo*/}
                  {/*   src={videoSrc}*/}
                  {/*   controls={false}*/}
                  {/*   autoPlay={true}*/}
                  {/*   loop={true}*/}
                  {/*   muted={true}*/}
                  {/*   classes={{ width: 'auto', margin: 'auto', height: '380px', objectFit: 'cover', borderRadius: '8px',*/}
                  {/*      boxShadow: videoLoaded ? '0px 0px 10px 0px rgba(0,0,0,0.1)': '' ,*/}
                  {/*   }}*/}

                  {/*/>*/}
                  {
                     asyncPage ?
                        <img src={videoSrc} style={{ width: '90%', margin: 'auto', height: 'auto', objectFit: 'cover', borderRadius: '8px' }} />
                        :
                        <video
                           style={{
                              width: 'auto', margin: 'auto', height: '380px', objectFit: 'cover', borderRadius: '8px',
                              boxShadow: videoLoaded ? '0px 0px 10px 0px rgba(0,0,0,0.1)' : '',
                           }}
                           controls={false}
                           autoPlay={true}
                           loop={true}
                           muted={true}
                           playsInline={true}
                           onLoadedData={() => { setVideoLoaded(true); }}
                        >
                           <source
                              src={videoSrc}
                              // src="https://openaccessimages.s3.eu-west-2.amazonaws.com/1to1CoachingPreview.mp4"
                              type="video/mp4"
                           />
                           {t('common.browserNoVideo')}
                        </video>
                  }


               </Fade>

            </Grid>
         </Grid>
      </div>


   );
};

const SectionPlaceholder = (props) => {

   return (
      <div style={{width: '100%'}}>

         <SectionItem
            icon={"👥️"}
            checked={props.customChecked}
            title={props.title}
            tooltipLink={props.tooltipLink}
            description={props.description}
            buttonText={props.buttonText}
            buttonAction={props.buttonAction}
            buttonTextSecondary={props.buttonTextSecondary}
            titleicon1={props.titleicon1}
            titleicon2={props.titleicon2}
            titleicon3={props.titleicon3}
            title1={props.title1}
            title2={props.title2}
            title3={props.title3}
            description1={props.description1}
            description2={props.description2}
            description3={props.description3}
            buttonActionSecondary={props.buttonActionSecondary}
            // customComponent={props.firstCommunityComponent}
            showExitMark={false}
            videoSrc={props.videoSrc}
            noMembers={props.noMembers}
            noPaidDMMembers={props.noPaidDMMembers}
            paidDMsActiveSettings={props.paidDMsActiveSettings}
            paidDMsModal={props.paidDMsModal}
            paidDMs_show={props.paidDMs_show}
            messagePage={props.messagePage}
            asyncPage={props.asyncPage}
            windowWidth={props.windowWidth}
         />

         {/* We can add more or less items as needed*/}
      </div>
   );
};

export default SectionPlaceholder;